(function () {
  const HANDLE_MAP = {
    'white': 'realwriter-y813-thermal-printer-white',
    'black': 'realwriter-y813-thermal-printer-black',
    'pink': 'realwriter-y813-thermal-printer-pink',
  };

  function getLangPrefix() {
    const match = window.location.pathname.match(/^\/([\w-]{2,5})\//);
    const excluded = ['products', 'collections', 'pages', 'blogs', 'cart'];
    if (match && !excluded.includes(match[1])) {
      return '/' + match[1];
    }
    return '';
  }

  function init() {
    const swatches = document.querySelectorAll('input[type="radio"][name="Color"]');
    swatches.forEach((el) => {
      el.addEventListener('change', handleChange);
    });
  }

  function handleChange(e) {
    const value = e.target.value;
    const handle = HANDLE_MAP[value];
    if (handle && !window.location.pathname.endsWith(handle)) {
      window.location.href = getLangPrefix() + '/products/' + handle;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
